import CategorySliderCard from './category-slider-card'

export default CategorySliderCard
